import React from "react";
import { deleteMain, getSizes } from "../../../api";
import { Await, defer, useLoaderData } from "react-router-dom";
import DataGrid from "../../../Component/DataGrid";
import ActionButton from "../../../Component/ActionButton";
import ProductSizeModal from "./ProductSizeModal";

export const loader = ({ request }) => {
  const url = new URL(request.url);
  const sort = url.searchParams.get("sort");
  const order = url.searchParams.get("order");
  const search = url.searchParams.get("search");

  const PromisedData = getSizes(sort, order, search, "AvailableDiskSizes");
  return defer({ data: PromisedData });
};

export default function ProductsSize() {
  const data = useLoaderData();
  const [actionData, setActionData] = React.useState({});
  const Actions = (p) => {
    return (
      <div className="d-flex h-100 justify-content-center align-items-center gap-2">
        <ActionButton
          data-bs-toggle="modal"
          data-bs-target="productSizeModal"
          onClick={() => console.log(p.data)}
        />

        <ActionButton
          p={p}
          isDelete={true}
          deleteFunc={deleteMain}
          deletePaymentType="AvailableDiskSizes"
        />
      </div>
    );
  };
  const [colDefs, setColDefs] = React.useState([
    {
      field: "name",
    },

    {
      field: "sizeInGB",
    },

    {
      field: "actions",
      cellRenderer: Actions,
    },
  ]);
  return (
    <section className="p-3">
      <React.Suspense
        fallback={
          <div className="w-100 h-screen d-flex justify-content-center align-items-center">
            <span className="loader-admin">Loading</span>
          </div>
        }
      >
        <Await resolve={data.data}>
          {(data) => {
            return (
              <DataGrid
                modalType={"productSizeModal"}
                setActionData={setActionData}
                hasCreate={true}
                data={data}
                col={colDefs}
              />
            );
          }}
        </Await>
      </React.Suspense>

      <ProductSizeModal actionData={actionData} />
    </section>
  );
}
